import { AxiosResponse } from "axios";
import advService from "../../util/advService";
import {
    ALL_CLAIMS_GET,
    CLAIM_CUSTOMERCARE_GET,
    UPLOAD_DOCUMENT_TIMELINE_GET,
} from "../../util/newconfig";
import { JavaResponse } from "../../types";
import { CLAIM_OPERATIONTEAM } from "../../util/config";
import { CustomerCareDto } from "../../types/DTO/claimsDTO";

type ClaimContact = {
    email: string;
    name: string;
    phone: string;
    step2: string;
    step3: string;
    step6: string;
    claimFileButton: boolean;
    claimIntimationText?: string;
    claimDocumentUpload: boolean;
    domain: string;
    superTopup: boolean;
    claimFilledForm: boolean;
    escalationMatrixDTOS: any[];
};

export interface ClaimDocumentsDto {
    claim_form: boolean;
    employee_id_proof: boolean;
    patient_id_proof: boolean;
    back_account_details: boolean;
    discharge_summary: boolean;
    upload_final_bill: boolean;
    upload_receipts: boolean;
    upload_other_bills_and_payment_receipts: boolean;
    upload_lab_report: boolean;
    upload_implant_sticker: boolean;
    upload_mlc_fir: boolean;
    upload_other_documents: boolean;
    ckyc: boolean;
    kyc_bank: boolean;
    kyc_patient: boolean;
    kyc_employee: boolean;
    deficient_document: boolean;
}

export const claimsService = {
    employer: {
        getClaimContact: async (uuid?: string): Promise<CustomerCareDto> => {
            return new Promise((resolve, reject) => {
                const finalUuid = uuid || sessionStorage.getItem("uuid");

                advService(
                    {
                        ...CLAIM_CUSTOMERCARE_GET,
                        url: CLAIM_CUSTOMERCARE_GET.url + finalUuid,
                    },
                    {},
                    (
                        response: AxiosResponse<JavaResponse<CustomerCareDto>>
                    ) => {
                        if (response.data.success) {
                            resolve(response.data.response);
                            return;
                        }
                        reject(response.data.message);
                    }
                );
            });
        },
        getOperationContact: async (uuid: string) => {
            return new Promise((resolve, reject) => {
                advService(
                    {
                        url:
                            CLAIM_OPERATIONTEAM +
                            sessionStorage.getItem("uuid"),
                    },
                    {},
                    (response: AxiosResponse<JavaResponse<ClaimContact>>) => {
                        if (response.data.success) {
                            resolve(response.data.response);
                            return;
                        }
                        reject(response.data.message);
                    }
                );
            });
        },
    },
    claim: {
        getAllClaims: async () => {
            return new Promise((resolve, reject) => {
                advService(
                    ALL_CLAIMS_GET,
                    {},
                    (response: AxiosResponse<JavaResponse<any[]>>) => {
                        if (response.data.success) {
                            resolve(response.data.response);
                            return;
                        }
                        reject(response.data.message);
                    }
                );
            });
        },
        getDocumentTimeline: async (
            internalId: string
        ): Promise<ClaimDocumentsDto | null> => {
            return new Promise((resolve, reject) => {
                const config = {
                    ...UPLOAD_DOCUMENT_TIMELINE_GET,
                    url: UPLOAD_DOCUMENT_TIMELINE_GET.url.replace(
                        "{claimId}",
                        internalId
                    ),
                };
                advService(
                    config,
                    {},
                    (
                        response: AxiosResponse<
                            JavaResponse<{
                                d_claim_documents: ClaimDocumentsDto;
                            }>
                        >
                    ) => {
                        if (response.data.success) {
                            resolve(response.data.response.d_claim_documents);
                            return;
                        }
                        reject(response.data.message);
                    }
                );
            });
        },
    },
};
